import { useQuery } from "@tanstack/react-query";
import { useGetIdentity } from "ra-core";
import { supabase } from "../providers/supabase/supabase";

export function useHasPermission(permissionSlug: string): { hasPermission: boolean; isLoading: boolean } {
  // BYPASS: Allow all permissions for staging
  return { hasPermission: true, isLoading: false };
}
